export default __webpack_public_path__ + "files/a7271f0d46db9ac49182fe5243311163.jpg";